module.exports = __webpack_public_path__ + "img/biei_nobori2.442a1779.png";